import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useDocuments } from '../../api';
import type { DocumentDto } from '../../api/generated/client';
import { AdminContentScreen, DocumentEditor } from '../../components/admin';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { AVAILABLE_LANGUAGES } from '../../i18n/i18nextInit';

const emptyDocument: DocumentDto = {
    id: -1,
    name: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    documentFiles: [],
    excludedDomiciles: [],
    includedDomiciles: [],
    global: false,
};

export const AdminDocuments: FunctionComponent = () => {
    const { data: documents } = useDocuments();

    const [documentId, setSearchParams] = useNumberSearchParams('document');
    const displayedItem = useMemo(
        () => (documentId != null ? documents?.find((d) => d.id === documentId) || emptyDocument : undefined),
        [documentId, documents],
    );

    const goToDoc = (docId: number) => setSearchParams({ document: docId.toString() });

    return (
        <AdminContentScreen
            items={documents}
            displayedItem={displayedItem}
            onCreateClick={() => goToDoc(-1)}
            onItemClick={goToDoc}
            itemEditorComponent={displayedItem ? <DocumentEditor document={displayedItem} /> : null}
        />
    );
};
